import { render, staticRenderFns } from "./my_code.vue?vue&type=template&id=2874a218&"
import script from "./my_code.vue?vue&type=script&lang=js&"
export * from "./my_code.vue?vue&type=script&lang=js&"
import style0 from "./my_code.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports